(function(){
'use strict';

/* Fork of 'cpStripeWidget' */
angular.module('classy').component('egPayStripe', {
  templateUrl: 'global/embedded-giving/pay/components/stripe/eg.pay.components.stripe', // same folder as this
  bindings: {
    cardErrorClassName: '@',
    inputClassName: '@',
    sourceData: '<',
    model: '<',
    hidePostal: '<',
    currency: '<'
  },
  controller: ["$rootScope", "scStripeService", "scFeeOnTopService", "bugsnagClient", function CpStripeWidgetCtrl($rootScope, scStripeService, scFeeOnTopService, bugsnagClient) {
    var DEFAULTS = {
      sourceData: {}
    };

    this.$onChanges = function () {
      var _this = this;

      /* Setup defaults and properties */
      _.defaultsDeep(this, DEFAULTS);
      this.$errorMessageElement = $('#card-errors');
      this.$errorMessageElement.text('').hide();
      this.cardElement = document.getElementById('card-element');

      var classes = { base: this.inputClassName };
      var style = {
        base: {
          fontFamily: 'system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Open Sans","Helvetica Neue",sans-serif'
        }
      };

      /* Set parent api bindings */
      this.model.getSource = this.getSource.bind(this);
      this.model.onError = this.onError.bind(this);

      /* Init stripe instance, elements, etc. */
      scStripeService.init().then(function () {
        _this.stripe = scStripeService.stripe;
        _this.elements = _this.stripe.elements();
        _this.card = _this.elements.create('card', {
          style: style,
          classes: classes,
          hidePostalCode: _this.hidePostal
        });
        _this.card.mount(_this.cardElement);
        _this.card.addEventListener('change', _this.onChange.bind(_this));
      });
    };

    /**
     * getSource
     *
     * Calls the stripe api method createSource on the stripe card element, converting the
     * raw card details into a stripe source object that can be charged by the pay api.
     *
     * Todo: add capability to accept a type param, to decide which stripe element to pull
     * the source from as we deepen our breadth of payment options
     * @return Promise - resolves to the source object
     */
    this.getSource = function () {
      var _this2 = this;

      return this.stripe.createSource(this.card, this.sourceData).then(function (result) {
        if (result.error) return _this2.onError(result.error);

        var source = result.source;


        if (!source) {
          return _this2.onError(new Error('source object missing in stripe response'));
        }

        _this2.model.source = source;

        return source;
      });
    };

    this.onError = function (error) {
      if (error.type === 'validation_error') {
        this.$errorMessageElement.text(error.message).show();
      } else if (error.type) {
        bugsnagClient.notify(new Error('Stripe Error: ' + error.type + ' - ' + error.message));
      } else {
        bugsnagClient.notify(error);
      }
      throw new Error(error.message);
    };

    this.onChange = function (event) {
      if (event.error) {
        $rootScope.$broadcast('eg.donation-payment.is-valid', { isValid: false });
        this.$errorMessageElement.text(event.error.message).show();
      } else {
        this.$errorMessageElement.text('').hide();
        // if event isn't 'complete' dont send 'is valid true'
        if (event.complete) {
          $rootScope.$broadcast('eg.donation-payment.is-valid', { isValid: true });
        } else {
          $rootScope.$broadcast('eg.donation-payment.is-valid', { isValid: false });
        }
      }
      var previousIsAmexValue = scFeeOnTopService.isAmex;
      var hasAmex = false;
      if (event.brand === 'amex' || event.brand === 'american_express') {
        hasAmex = true;
        $rootScope.$broadcast('donationPage:recalculateFees');
        $rootScope.$broadcast('cart:setIsAmex', hasAmex);
      }
      scFeeOnTopService.setAmex(hasAmex);

      if (previousIsAmexValue !== scFeeOnTopService.isAmex) {
        $rootScope.$broadcast('donationPage:recalculateFees');
        $rootScope.$broadcast('cart:setIsAmex', hasAmex);
      }
    };
  }]
});
})();